import { graphql } from "babel-plugin-relay/macro";
import { Button } from "primereact/button";
import { useMutation } from "react-relay";
import { toast } from "react-toastify";
import { StartPublishingButton_StartPublishingV2Mutation } from "../../../../../__generated__/StartPublishingButton_StartPublishingV2Mutation.graphql";
import { TREE_I18N_KEY, TREE_I18N_MAP } from "../../../../../lms-admin-impl/i18n/tree.i18n";
import { useDialogLogic } from "../../../core/dialog/useDialogLogic";

const START_PUBLISHING_MUTATION = graphql`
	mutation StartPublishingButton_StartPublishingV2Mutation(
		$input: InfectopharmStartPublishingV2Input!
	) {
		Admin {
			PublishingV2 {
				infectopharmStartPublishingV2(input: $input) {
					tree {
						id
						...TreeEditorScreen_TreeFragment
					}
				}
			}
		}
	}
`;

interface OwnProps {
	rootNodeId: string;
	className?: string;
}

export const StartPublishingButton = ({ rootNodeId, className }: OwnProps) => {
	const [startPublishing, isStartingPublishing] =
		useMutation<StartPublishingButton_StartPublishingV2Mutation>(START_PUBLISHING_MUTATION);
	const { showDialog, dialogComponent } = useDialogLogic();

	return (
		<>
			{dialogComponent}
			<Button
				disabled={isStartingPublishing}
				className={className}
				tooltip={`${TREE_I18N_MAP(TREE_I18N_KEY.tree)} veröffentlichen`}
				onClick={() => {
					showDialog({
						title: `${TREE_I18N_MAP(TREE_I18N_KEY.tree)} veröffentlichen`,
						content: "Das Veröffentlichen kann nicht rückgängig gemacht werden",
						affirmativeText: "Veröffentlichen",
						negativeText: "Abbrechen",
						dialogCallback: (result) => {
							if (result === "Accept") {
								startPublishing({
									variables: {
										input: {
											rootNodeId: rootNodeId,
										},
									},
									onCompleted: () => {
										window.location.reload();
									},
									onError: () => {
										toast.error(
											"Fehler beim Veröffentlichen. Der Baum ist nicht valide.",
										);
									},
								});
							}
						},
					});
				}}
				icon={"pi pi-send"}
			/>
		</>
	);
};
